export default {
    "covers": "",
    "group_items": [{
        "items": [{
            "name": "",
            "mode": "",
            "identifier": "",
            "create_at": "",
            "placeholder": ""
        }, ],
        "name": "",
        "choice_mode": "",
        "identifier": "",
        "create_at": ""
    }, ],
    "name": "",
    "identifier": "",
    "create_at": "",
    "mode": "",
    "test_instruction": {
        "name": "",
        "instruction": "",
        "mode": "",
    }
}